module.exports = __webpack_public_path__ + "fonts/osp-din-webfont.74d37ed6.woff";